// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';

import { setForm } from '../../../actions';
import {
    MY_ACCOUNT_FORM,
    CONFIRM_GDPR_EXPORT_FORM,
} from '../../../constants/forms';
import i18n from '../../../i18n/i18n.js';

type Props = {
    branding: {
        paywall_buttons_bg_color: string,
        paywall_buttons_text_color: string,
    },
    resetExportMessage: Function,
    exportData: Function,
    setForm: Function,
};

export class ExportData extends Component<Props> {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
        };
    }

    back = () => {
        this.props.setForm(MY_ACCOUNT_FORM);
    };

    handleExportModal = () => {
        this.props.setForm(CONFIRM_GDPR_EXPORT_FORM);
    };

    render() {
        // button
        let backgroundButtonColor = this.props.branding.paywall_buttons_bg_color
            ? this.props.branding.paywall_buttons_bg_color
            : '#00aae6';

        let lng = this.props.language;

        return (
            <Fragment>
                <section id="ipx-maincontent" className="gdpr-text">
                    <h2>{i18n.t('export_question', { lng })}</h2>
                    <div className="gdpr-inside">
                        <p>
                            {i18n.t('first_export', { lng })}
                            <br />
                            <br />- {i18n.t('second_export', { lng })} <br />-{' '}
                            {i18n.t('third_export', { lng })} <br />-{' '}
                            {i18n.t('fourth_export', { lng })} <br />-{' '}
                            {i18n.t('fifth_export', { lng })} <br />-{' '}
                            {i18n.t('sixth_export', { lng })} <br />
                            <br />
                            {i18n.t('last_export', { lng })}
                        </p>
                    </div>
                    <div className="gdpr-border">
                        <div className="buttonholder buttonholder-gdpr">
                            <a href="#" onClick={this.back} className="back">
                                &lang; {i18n.t('modal_back', { lng })}
                            </a>
                            <button
                                onClick={this.handleExportModal}
                                style={{
                                    backgroundColor: backgroundButtonColor,
                                    color: '#fff',
                                    border: `solid 1px ${backgroundButtonColor}`,
                                }}
                            >
                                <span className="buttonlabel" />
                                {i18n.t('export', { lng })}
                            </button>
                        </div>
                    </div>
                </section>
            </Fragment>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        branding: state.branding,
        language: state.auth.language,
    };
};

export default connect(
    mapStateToProps,
    {
        setForm,
    }
)(ExportData);



// WEBPACK FOOTER //
// ./src/containers/Forms/GDPR/ExportData.js